import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  fillingPersonReturn,
  readFillingPersonReturn,
} from "data/server_apis/inventoryService";

const fillingPersonReturnAdapter = createEntityAdapter({
  selectId: (fillingPersonReturn) => fillingPersonReturn.id,
});

export const getFillingPersonReturnThunk = createAsyncThunk(
  "fillingPersonStockReturn/get",
  async ({ page, from_date, to_date, fillingPerson }, { rejectWithValue }) => {
    try {
      return (
        await fillingPersonReturn(page, from_date, to_date, fillingPerson)
      ).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const readFillingPersonReturnThunk = createAsyncThunk(
  "fillingPersonStockReturn/read",
  async (id, { rejectWithValue }) => {
    try {
      return (await readFillingPersonReturn(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const fillingPeronReturnLogSlice = createSlice({
  name: "fillingPersonReturn",
  initialState: fillingPersonReturnAdapter.getInitialState({
    status: {},
    readStatus: {},
    pageCount: 1,
  }),
  extraReducers: (builder) => {
    builder
      .addCase(getFillingPersonReturnThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getFillingPersonReturnThunk.rejected, (state, action) => {
        state.status = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getFillingPersonReturnThunk.fulfilled, (state, action) => {
        console.log(action.payload);
        fillingPersonReturnAdapter.setAll(state, action.payload.results);
        // state.pageCount = action.payload.total_pages
      });

    builder
      .addCase(readFillingPersonReturnThunk.pending, (state, action) => {
        state.readStatus = { loading: action.meta.arg };
      })
      .addCase(readFillingPersonReturnThunk.rejected, (state, action) => {
        state.readStatus = {
          error: action.meta.arg,
          errorMessage: action.payload?.message,
        };
      })
      .addCase(readFillingPersonReturnThunk.fulfilled, (state, action) => {
        console.log(action.payload);
        fillingPersonReturnAdapter.updateOne(state, {
          id: action.meta.arg,
          changes: { status: true },
        });
      });
  },
  reducers: {},
});

export const fillingPersonReturnSelector =
  fillingPersonReturnAdapter.getSelectors((state) => state.fillingPersonReturn);

export const {} = fillingPeronReturnLogSlice.actions;

export default fillingPeronReturnLogSlice.reducer;
